var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 23141",
    d: "M0 3.31977C0 1.90592 1.14615 0.759766 2.56 0.759766H29.44C30.8538 0.759766 32 1.90592 32 3.31977V18.6798C32 20.0936 30.8538 21.2398 29.44 21.2398H2.56C1.14615 21.2398 0 20.0936 0 18.6798V3.31977Z",
    fill: "#E2E8F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 23142",
    d: "M2.55957 5.23961C2.55957 4.88615 2.84611 4.59961 3.19957 4.59961H10.2396C10.593 4.59961 10.8796 4.88615 10.8796 5.23961V9.71961C10.8796 10.0731 10.593 10.3596 10.2396 10.3596H3.19957C2.84611 10.3596 2.55957 10.0731 2.55957 9.71961V5.23961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23143",
    x: 2.55957,
    y: 14.8398,
    width: 5.76,
    height: 2.56,
    fill: "#A5B4CF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23144",
    x: 9.59961,
    y: 14.8398,
    width: 5.76,
    height: 2.56,
    fill: "#A5B4CF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23145",
    x: 16.6396,
    y: 14.8398,
    width: 5.76,
    height: 2.56,
    fill: "#A5B4CF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23146",
    x: 23.6797,
    y: 14.8398,
    width: 5.76,
    height: 2.56,
    fill: "#A5B4CF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardLg);
export default __webpack_public_path__ + "static/media/credit-card-lg.bff82538f6e78ec3fdf1b28ab47c2d0c.svg";
export { ForwardRef as ReactComponent };